import type { LanguageOption } from './baseTypes';

export interface TextbookLinkDTO {
    displayText: string;
    link: string;
}

export interface TextbookLinks {
    teacherEdition: TextbookLinkDTO[];
    studentEdition: TextbookLinkDTO[];
}

const FLIPBOOK_BASE_URL = 'https://teacher-files.paradigmmath.com';

type Edition = 'TE' | 'SE';

// 'Vol 1A' -> https://.../EN/_flipbook/TE/G3-TE-Vol-1A/index.html
function buildLinks(
    edition: Edition,
    grade: string,
    language: LanguageOption,
    volumes: string[]
): TextbookLinkDTO[] {
    return volumes.map((displayText) => ({
        displayText,
        link: `${FLIPBOOK_BASE_URL}/${language}/_flipbook/${edition}/G${grade}-${edition}-${displayText.replace(/ /g, '-')}/index.html`,
    }));
}

// Single source of truth for eBook flipbook links, shared by the eBooks page and resource search.
export function getTextbookLinks(grade: string, language: LanguageOption): TextbookLinks {
    if (grade === 'TK') {
        return {
            teacherEdition: buildLinks('TE', grade, language, [
                'Vol CC',
                'Vol OA',
                'Vol MD',
                'Vol G',
            ]),
            studentEdition: buildLinks('SE', grade, language, ['Resources']),
        };
    }

    if (grade === 'K') {
        return {
            teacherEdition: buildLinks('TE', grade, language, ['Vol 1', 'Vol 2']),
            studentEdition: buildLinks('SE', grade, language, ['Vol 1', 'Vol 2']),
        };
    }

    return {
        teacherEdition: buildLinks('TE', grade, language, ['Vol 1A', 'Vol 1B', 'Vol 2A', 'Vol 2B']),
        studentEdition: buildLinks('SE', grade, language, ['Vol 1', 'Vol 2']),
    };
}
